import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=22acfdbc&scoped=true&"
import script from "./Allocation.vue?vue&type=script&lang=js&"
export * from "./Allocation.vue?vue&type=script&lang=js&"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=22acfdbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22acfdbc",
  null
  
)

export default component.exports